import '@angular/compiler';
import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

const finalConfig = {
  providers: [
    provideZoneChangeDetection(),
    ...appConfig.providers
  ]
};

bootstrapApplication(AppComponent, finalConfig)
  .catch((err) => console.error(err));
